// app-routing.module.ts
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CountComponent } from './components/count/count.component';
import { DateFacilityFlowComponent } from './components/date-facility-flow/date-facility-flow.component';

const routes: Routes = [
  { path: '', component: DateFacilityFlowComponent },
  { path: 'facility-flow', component: CountComponent },
  { path: 'date-facility-flow', component: DateFacilityFlowComponent },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
